import { render, staticRenderFns } from "./sdproduct3.vue?vue&type=template&id=1f173b67&scoped=true"
import script from "./sdproduct3.vue?vue&type=script&lang=js"
export * from "./sdproduct3.vue?vue&type=script&lang=js"
import style0 from "./sdproduct3.vue?vue&type=style&index=0&id=1f173b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f173b67",
  null
  
)

export default component.exports